module.exports = __webpack_public_path__ + "img/profitability5.7df11edb.png";